import { errorToastify } from "../Components/Common/Toaster";

const errorResponseHandler = (response) => {
  let statusCode = response.statusCode || response.data.statusCode;
  let message = response.message || response.data.message;
  let data = response.data || response.data.data;

  // eslint-disable-next-line default-case
  switch (statusCode) {
    case 202:
      errorToastify(message);
      break;
    case 400:
      errorToastify(message);
      break;
    case 500:
      errorToastify("An error occurred while processing your request.");
      break;
    case 401:
      errorToastify(message);
      break;
    case 402:
      errorToastify(message);
      break;
    case 403:
      errorToastify(message);
      break;
    case 409:
      errorToastify(message);
      break;
    default:
      console.log("status code: " + statusCode, data);
  }
};

export default errorResponseHandler;
